import { ChemistryRangesSpecPage } from "./ChemistryRangesSpecPage";

const LabChemistryRanges = () => {
	return <ChemistryRangesSpecPage />;
};
export default LabChemistryRanges;
